import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import FuncionariosService from '../../../../../services/funcionarios';

const Funcionario = () => {
    let { id } = useParams()
    const [senha, setSenha] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [redirect, setRedirect] = useState(false);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const func = await FuncionariosService.senha(id, {
                senha: senha
            })
            if (func.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (sucesso && !redirect) {
        setTimeout(() => {
            setRedirect(true);
        }, 3000); // 3 segundos
    }

    if (redirect) {
        return <Navigate to="/rh/funcionarios/listar" />;
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={3}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="senha">
                                        <Form.Label>Nova senha</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="senha"
                                            value={senha}
                                            onChange={e => setSenha(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >

                    </Row>
                    <br />
                    <Link to={'/rh/funcionarios/listar'}>
                        <Button variant="danger" type="button">
                            Cancelar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Senha alterada com sucesso!<br />
                        Redirecionando em 3 segundos...
                    </Alert>
                </Container>
            </Fragment>
        )
    }
}

export default Funcionario;